var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_501_9473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.174 9.71058C19.174 8.93171 19.1121 8.36334 18.9782 7.77393H10.2725V11.2894H15.3825C15.2796 12.163 14.7232 13.4787 13.4869 14.3628L13.4695 14.4805L16.2221 16.659L16.4128 16.6784C18.1643 15.0259 19.174 12.5945 19.174 9.71058Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2724 18.9729C12.7759 18.9729 14.8776 18.1308 16.4128 16.6783L13.4868 14.3627C12.7038 14.9205 11.6529 15.31 10.2724 15.31C7.82036 15.31 5.73924 13.6575 4.99738 11.3735L4.88864 11.383L2.02644 13.6459L1.98901 13.7522C3.51379 16.8467 6.64581 18.9729 10.2724 18.9729Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9974 11.3736C4.80165 10.7842 4.68836 10.1526 4.68836 9.50004C4.68836 8.84742 4.80165 8.21592 4.9871 7.62651L4.98191 7.50098L2.08385 5.20166L1.98903 5.24774C1.3606 6.53185 1 7.97386 1 9.50004C1 11.0262 1.3606 12.4682 1.98903 13.7523L4.9974 11.3736Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2724 3.68991C12.0135 3.68991 13.188 4.45826 13.8577 5.10036L16.4746 2.49004C14.8674 0.963864 12.7759 0.0270996 10.2724 0.0270996C6.64581 0.0270996 3.51379 2.15321 1.98901 5.24766L4.98708 7.62643C5.73924 5.34242 7.82036 3.68991 10.2724 3.68991Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_9473"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 18.1739,
    height: 19,
    rx: 9.08696,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.1bd9994728152cac264e29713142c925.svg";
export { ForwardRef as ReactComponent };